import React, { Component } from "react";

declare const window: any;
function AnalyticsWrapper(WrappedComponent: any) {
  return class withAnalyticsWrapper extends Component {
    dev = false;
    pollTime = 1000;
    pollNum = 4;
    defaultObj = {
      type: "dynamic-page",
      data: {
        app_name: "web",
        section: ["show info"],
        device: "web",
        device_type: "web",
        content_type: "adbp:none",
        episode_num: "no value",
        mvpd: "no value",
        mvpd_status: "no value",
        network: "tbs",
        season_num: "no value",
        series_name: "American Dad",
        user_id: "no value"
      }
    };

    state = {
      objArray: new Set()
    };

    trackMetrics = window.trackMetrics;
    constructor(props: any) {
      super(props);
      this.dev = this.determineDevMode(props);
      this.pollTime = 1000;
      this.pollNum = 4;
      // this.defaultObj = {
      //   type: "dynamic-page",
      //   data: {
      //     app_name: "tnt|us|english",
      //     content_type: "adbp:none",
      //     episode_num: "no value",
      //     mvpd: "no value",
      //     mvpd_status: "no value",
      //     network: "tnt",
      //     season_num: "no value",
      //     series_name: "no value",
      //     user_id: "no value"
      //   }
      // };
      this.state = {
        objArray: new Set()
      };
      this.init();
    }

    componentDidUpdate() {
      this.fireCall(this.state.objArray);
    }

    init = () => {
      if (this.checkWindow()) {
        this.trackMetrics = window.trackMetrics;
      } else {
        // console.warn("Window object was not found. Waiting...");
        this.initPolling(0);
      }
      if (process.env.NODE_ENV === "development") {
        window.bindTracking = () => null;
      } else {
        window.bindTracking = this.bindTracking;
      }
    };

    determineDevMode = (props: any) => {
      let devModeFlag = props.dev;

      return process.env.NODE_ENV !== "production" && devModeFlag;
    };

    initPolling = (num: number) => {
      window.setTimeout(() => {
        if (this.checkWindow()) {
          this.trackMetrics = window.trackMetrics;
          this.fireCall(this.state.objArray);
        } else {
          if (num > this.pollNum) {
            // console.error("Window object was still not found. Ending polling.");
            this.includeDevTrackMetrics();
            return;
          } else {
            // console.warn("Window object was still not found. Retrying...");
            num++;
            this.initPolling(num);
          }
        }
      }, this.pollTime);
    };

    bindTracking = (payload: any) => {
      console.table(payload);
      this.storeCall(payload);
    };

    checkWindow = () => {
      return window.trackMetrics && typeof window.trackMetrics === "function";
    };

    includeDevTrackMetrics = () => {
      if (this.dev) {
        console.log("Dev mode detected. Including dev tracking function...");
        typeof window.trackMetrics === "undefined"
          ? (this.trackMetrics = () => {})
          : console.warn("");
        this.fireCall(this.state.objArray);
      }
    };

    fireCall = (objArray: any) => {
      if (
        typeof this.trackMetrics === "undefined" ||
        this.state.objArray.size === 0
      ) {
        return;
      }

      for (const obj of objArray) {
        try {
          let finalObj = this.formData(obj);
          if (this.dev) console.log("trackMetrics call with", finalObj);
          this.trackMetrics(finalObj);
          objArray.delete(obj);
        } catch (e) {
          console.error("trackMetrics failed with error", e);
        }
      }

      this.setState({
        objArray: objArray
      });
    };

    formData = (payload: any) => {
      const data = {
        type: payload.type ? payload.type : this.defaultObj.type,
        data: { ...this.defaultObj.data, ...payload.data }
      };

      return data;
    };

    storeCall = (obj: any) => {
      const objArray = this.state.objArray;

      objArray.add(obj);

      this.setState({
        objArray: objArray
      });
    };

    render = () => {
      return (
        <WrappedComponent {...this.props} bindTracking={this.bindTracking} />
      );
    };
  };
}

export default AnalyticsWrapper;
